module.exports = __webpack_public_path__ + "img/status-change.12211f4f.png";